import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PromocodesListQuery } from "../graphql/queries";
import type {
  PromocodesListQueryType,
  PromocodesListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const usePromocodesQuery = (
  options?: QueryHookOptions<
    PromocodesListQueryType,
    PromocodesListQueryVariablesType
  >
) => {
  return useQuery<PromocodesListQueryType, PromocodesListQueryVariablesType>(
    PromocodesListQuery,
    options
  );
};
